function hasConsentForVendor(vendorID: string): boolean {
  const { __cmp } = window;
  if (!__cmp) {
    return false;
  }
  const cmpData = __cmp('getCMPData');
  const consent = cmpData?.vendorConsents[vendorID];
  return consent || false;
}

export function enableTrackingAndAnalytics(): boolean {
  return process.env.NODE_ENV === 'production';
}

export function cmpScriptElement({
  src,
  vendorID,
  async = false,
}: {
  src?: string;
  vendorID: string;
  async?: boolean;
}): HTMLScriptElement {
  const hasConsent = hasConsentForVendor(vendorID);

  const script = document.createElement('script');
  script.async = async;

  if (!hasConsent) {
    script.type = 'text/plain';
    script.className = 'cmplazyload';
    script.setAttribute('data-cmp-vendor', vendorID);
  }

  if (src) {
    if (hasConsent) {
      script.src = src;
    } else {
      script.setAttribute('data-cmp-src', src);
    }
  }

  return script;
}
